import {MouseEvent, useState} from "react";

export const useThreeDotsMenu = <TElement extends HTMLElement = HTMLElement>() => {

    const [anchorThreeDotsEl, setAnchorThreeDotsEl] = useState<null | TElement>(null);
    const handleThreeDotsOpen = (event: MouseEvent<TElement>) => {setAnchorThreeDotsEl(event.currentTarget);};
    const handleThreeDotsClose = () => {setAnchorThreeDotsEl(null);};

    return {
        anchorThreeDotsEl, setAnchorThreeDotsEl,
        handleThreeDotsOpen, handleThreeDotsClose,
        open: Boolean(anchorThreeDotsEl)
    }
}